import {
  ComboboxControl,
  ControlItemValue,
  Form,
  RadioButtonControl,
} from '../../../../types/types';
import { ApiMethodItems } from '../../../../api/utils/fetchControlApiMethodOptions';
import { isApiMethodItems } from '../../../../utils/isApiMethodItems';

// Pair of form-item name and its dynamic (apiMethod) control items, ready to be
// passed to fetchControlApiMethodOptions or useControlApiMethodItems.
export type DynamicListControlItem = {
  name: string;
  controlItems: ApiMethodItems;
  controlDefault?: ControlItemValue;
};

// Collects radioBtn/combobox items with dynamic apiMethod options; used by useFormOptionsPrefetch
// to prefetch defaults for inactive-tab controls. form.items is flat — no recursion needed.
export const findDynamicListControlItems = (
  form: Form | null | undefined
): DynamicListControlItem[] => {
  if (!form?.items) return [];

  const result: DynamicListControlItem[] = [];
  form.items.forEach((item) => {
    if (!item.name) return;
    if (item.control?.type !== 'radioBtn' && item.control?.type !== 'combobox')
      return;

    const controlItems = (item.control as RadioButtonControl | ComboboxControl)
      .items;
    // Skip static array items — those are already handled in createRelevantFormData.
    if (!isApiMethodItems(controlItems)) return;

    result.push({
      name: item.name,
      controlItems,
      controlDefault: item.control.default,
    });
  });

  return result;
};
